module.exports = __webpack_public_path__ + "static/media/militaryStyleBag.a85f3fce.svg";